"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = exports.decodeAlert = exports.AlertAction = exports.AlertSubdomain = exports.AlertDomain = exports.AlertSeverity = void 0;

var uuid_1 = require("./support/uuid");

var alert_1 = require("./http/alert");

var AlertSeverity;

(function (AlertSeverity) {
  AlertSeverity[AlertSeverity["NotApplicable"] = 0] = "NotApplicable";
  AlertSeverity[AlertSeverity["Critical"] = 1] = "Critical";
  AlertSeverity[AlertSeverity["Warning"] = 2] = "Warning";
  AlertSeverity[AlertSeverity["Info"] = 3] = "Info";
  AlertSeverity[AlertSeverity["Debug"] = 4] = "Debug";
})(AlertSeverity = exports.AlertSeverity || (exports.AlertSeverity = {}));

;
var AlertDomain;

(function (AlertDomain) {
  AlertDomain[AlertDomain["NotApplicable"] = 0] = "NotApplicable";
  AlertDomain[AlertDomain["Battery"] = 2] = "Battery";
  AlertDomain[AlertDomain["Clock"] = 36] = "Clock";
  AlertDomain[AlertDomain["Communication"] = 1] = "Communication";
  AlertDomain[AlertDomain["Configuration"] = 7] = "Configuration";
  AlertDomain[AlertDomain["Demand"] = 8] = "Demand";
  AlertDomain[AlertDomain["Firmware"] = 11] = "Firmware";
  AlertDomain[AlertDomain["Installation"] = 6] = "Installation";
  AlertDomain[AlertDomain["LoadControl"] = 15] = "LoadControl";
  AlertDomain[AlertDomain["Logs"] = 17] = "Logs";
  AlertDomain[AlertDomain["Metrology"] = 21] = "Metrology";
  AlertDomain[AlertDomain["Modem"] = 19] = "Modem";
  AlertDomain[AlertDomain["Power"] = 26] = "Power";
  AlertDomain[AlertDomain["RCDSwitch"] = 31] = "RCDSwitch";
  AlertDomain[AlertDomain["Security"] = 12] = "Security";
  AlertDomain[AlertDomain["Temperature"] = 35] = "Temperature";
  AlertDomain[AlertDomain["Watchdog"] = 37] = "Watchdog";
})(AlertDomain = exports.AlertDomain || (exports.AlertDomain = {}));

;
var AlertSubdomain;

(function (AlertSubdomain) {
  AlertSubdomain[AlertSubdomain["NotApplicable"] = 0] = "NotApplicable";
  AlertSubdomain[AlertSubdomain["Access"] = 1] = "Access";
  AlertSubdomain[AlertSubdomain["Cover"] = 29] = "Cover";
  AlertSubdomain[AlertSubdomain["Current"] = 6] = "Current";
  AlertSubdomain[AlertSubdomain["DataLog"] = 33] = "DataLog";
  AlertSubdomain[AlertSubdomain["FirmwareReset"] = 47] = "FirmwareReset";
  AlertSubdomain[AlertSubdomain["Flow"] = 48] = "Flow";
  AlertSubdomain[AlertSubdomain["Frequency"] = 4] = "Frequency";
  AlertSubdomain[AlertSubdomain["HeadEndSystem"] = 52] = "HeadEndSystem";
  AlertSubdomain[AlertSubdomain["Identity"] = 10] = "Identity";
  AlertSubdomain[AlertSubdomain["MeterBus"] = 147] = "MeterBus";
  AlertSubdomain[AlertSubdomain["NeutralCurrent"] = 137] = "NeutralCurrent";
  AlertSubdomain[AlertSubdomain["PowerFactor"] = 27] = "PowerFactor";
  AlertSubdomain[AlertSubdomain["PowerQuality"] = 28] = "PowerQuality";
  AlertSubdomain[AlertSubdomain["Readings"] = 86] = "Readings";
  AlertSubdomain[AlertSubdomain["Recovery"] = 88] = "Recovery";
  AlertSubdomain[AlertSubdomain["Relay"] = 91] = "Relay";
  AlertSubdomain[AlertSubdomain["SetPoint"] = 101] = "SetPoint";
  AlertSubdomain[AlertSubdomain["Status"] = 17] = "Status";
  AlertSubdomain[AlertSubdomain["Tariff"] = 140] = "Tariff";
  AlertSubdomain[AlertSubdomain["Threshold"] = 261] = "Threshold";
  AlertSubdomain[AlertSubdomain["Time"] = 114] = "Time";
  AlertSubdomain[AlertSubdomain["Usage"] = 123] = "Usage";
  AlertSubdomain[AlertSubdomain["Voltage"] = 38] = "Voltage";
})(AlertSubdomain = exports.AlertSubdomain || (exports.AlertSubdomain = {}));

var AlertAction;

(function (AlertAction) {
  AlertAction[AlertAction["ArmedForClosure"] = 5] = "ArmedForClosure";
  AlertAction[AlertAction["Cancel"] = 8] = "Cancel";
  AlertAction[AlertAction["Cancelled"] = 10] = "Cancelled";
  AlertAction[AlertAction["Change"] = 13] = "Change";
  AlertAction[AlertAction["Changed"] = 24] = "Changed";
  AlertAction[AlertAction["Connect"] = 18] = "Connect";
  AlertAction[AlertAction["Connected"] = 42] = "Connected";
  AlertAction[AlertAction["Disconnect"] = 23] = "Disconnect";
  AlertAction[AlertAction["Disconnected"] = 68] = "Disconnected";
  AlertAction[AlertAction["Error"] = 79] = "Error";
  AlertAction[AlertAction["LossDetected"] = 47] = "LossDetected";
  AlertAction[AlertAction["Missing"] = 285] = "Missing";
  AlertAction[AlertAction["NotApplicable"] = 0] = "NotApplicable";
  AlertAction[AlertAction["NotFound"] = 160] = "NotFound";
  AlertAction[AlertAction["Reestablished"] = 49] = "Reestablished";
  AlertAction[AlertAction["Restarted"] = 53] = "Restarted";
  AlertAction[AlertAction["Reset"] = 214] = "Reset";
  AlertAction[AlertAction["Failed"] = 85] = "Failed";
  AlertAction[AlertAction["OutofRange"] = 40] = "OutofRange";
  AlertAction[AlertAction["OutofRangeCleared"] = 74] = "OutofRangeCleared";
  AlertAction[AlertAction["TamperDetected"] = 257] = "TamperDetected";
})(AlertAction = exports.AlertAction || (exports.AlertAction = {}));

function decodeAlert(a) {
  var uuid = undefined;

  if (a.unit && a.unit.length > 20) {
    uuid = new uuid_1.UUID(a.unit);
  }

  var resolvedAt = a.resolvedat;

  if (resolvedAt == null) {
    resolvedAt = a.resolvedAt;
  } else {
    resolvedAt = new Date(resolvedAt);
  }

  return new Alert(a.id, uuid, a.assetid, a.message, a.severity, new Date(a.time), a.resolved, resolvedAt, a.domain, a.subdomain, a.action);
}

exports.decodeAlert = decodeAlert;
/** Alerts are messages about something happening for a given UUID */

var Alert =
/** @class */
function () {
  function Alert(id, uuid, assetid, message, severity, time, resolved, resolvedAt, domain, subdomain, action) {
    if (uuid === void 0) {
      uuid = new uuid_1.UUID("00000000-0000-0000-0000-000000000000");
    }

    if (assetid === void 0) {
      assetid = "";
    }

    if (resolved === void 0) {
      resolved = false;
    }

    if (resolvedAt === void 0) {
      resolvedAt = new Date(0);
    }

    this.id = id;
    this.uuid = uuid;
    this.assetid = assetid;
    this.message = message;
    this.severity = severity;
    this.time = time;
    this.resolved = resolved;
    this.resolvedAt = resolvedAt;
    this.domain = domain;
    this.subdomain = subdomain;
    this.action = action;
    this.dismissed = false;
  }
  /**
   * Dismiss performs a remote dismissal of this alert to the API. This hides this alert from the main alerts lists but keeps it available
   * in the alert history. Basically used as a confirmation that the alert has been noted.
   *
   * @param cred the authorized credentials object for accessing the API
   * @returns A HTTP promise regarding the success of the operation
   */


  Alert.prototype.dismiss = function (cred) {
    var _this = this;

    return alert_1.dismiss(this.id, cred).then(function () {
      _this.dismissed = true;
    });
  };
  /**
   * Merge takes the data from the other alert given as a parameter and updates this with that that data, if present and if the ID:s match.
   * NOTE: This function mostly overwrites this alert with the data from the other one and does not perform any _intelligent_ merging.
   *
   * @param other - The candidate alert to merge with this one
   */


  Alert.prototype.merge = function (other) {
    if (this.id === other.id) {
      if (other.uuid && other.uuid.valid()) {
        this.uuid = other.uuid;
      }

      if (other.assetid && other.assetid.length > 0) {
        this.assetid = other.assetid;
      }

      if (other.message && other.message.length > 0) {
        this.message = other.message;
      }

      this.severity = other.severity;
      this.time = other.time;
      this.resolved = other.resolved;

      if (this.resolved) {
        this.resolvedAt = other.resolvedAt;
      }

      this.domain = other.domain;
      this.subdomain = other.subdomain;
      this.action = other.action;
      this.dismissed = other.dismissed;
    }
  };

  return Alert;
}();

exports.Alert = Alert;
;